import React from "react";
import { useSortable } from "@dnd-kit/sortable";
import styles from "../RulesTable.module.scss";

/**
 * SortableGroup wraps a group for drag-and-drop reordering.
 */
interface SortableGroupProps {
    readonly id: string;
    readonly children: (props: {
        listeners: React.HTMLAttributes<HTMLElement>;
        attributes: React.HTMLAttributes<HTMLElement>;
    }) => React.ReactNode;
}

export const SortableGroup = ({ id, children }: SortableGroupProps) => {
    const { setNodeRef, attributes, listeners } = useSortable({ id });
    // Default listeners/attributes to {} to satisfy React.HTMLAttributes
    return (
        <tbody ref={setNodeRef} className={styles.tableBody}>
            {children({
                listeners: listeners ?? {},
                attributes: attributes ?? {},
            })}
        </tbody>
    );
};
